import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { textStyles, colors } from "../../../../theme/foundations/generated";
import { getBorderColor, getBackgroundColor } from "../helpers";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "container",
    "infoContainer",
    "infoTop",
    "infoBottom",
    "title",
    "icon",
    "tag",
    "banner",
]);
const baseStyle = definePartsStyle(({ variant }) => ({
    container: {
        height: "96px",
        width: "100%",
        display: "flex",
        backgroundColor: getBackgroundColor(variant),
    },
    infoContainer: {
        flex: 1,
        minWidth: "134px",
        display: "flex",
        flexDirection: "column",
        rowGap: ".5rem",
        padding: "1rem 0rem 1rem 1rem",
        boxShadow: `inset 0px -1px 0px 0px ${getBorderColor(variant)}`,
    },
    infoTop: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        columnGap: ".5rem",
    },
    infoBottom: {},
    title: Object.assign({ color: "semantic.brand.primary" }, textStyles.body.largeBold),
    icon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: ".25rem",
        borderRadius: ".375rem",
        backgroundColor: `${colors.semantic.surface[1]}50`,
    },
    banner: {
        width: "186px",
        backgroundColor: "lightgrey",
    },
}));
const BenefitBannerTheme = defineMultiStyleConfig({
    baseStyle,
});
export default BenefitBannerTheme;
//# sourceMappingURL=BenefitBanner.default.js.map